import { AxiosError } from 'axios';

import { ProjectVendorsPayload } from 'src/project/types';

import { ApaduaAPI } from './ApaduaAPI';

export class ProjectVendorsAPI extends ApaduaAPI {
    resource: string = 'api/project/';

    getProjectVendors(projectId: string): any {
        return this.get(`${projectId}/vendors/`);
    }

    updateProjectVendors(payload: ProjectVendorsPayload, projectId: string): any {
        return this.put(`${projectId}/vendors/`, payload);
    }

    // eslint-disable-next-line
    handleError(error: AxiosError): any {
        const errors = error.response.data;
        let errorMessage = '';
        errors.forEach((err, index) => {
            const { detail, source } = err;
            const { pointer } = source;
            const field = pointer.split('/').pop();
            errorMessage += `Error ${index + 1}: ${detail} [${field}] \n`;
        });
        throw Error(errorMessage);
    }
}
